export default {
  title: '媒资库',
  icon: 'cloud',
  path: `http://rmt.gstai.com/sectionFiles`,
  // path: `/cloud/library`,
  hideSub: true,
  children: (pre => [
    {
      path: `http://rmt.gstai.com/sectionFiles`,
      // path: `${pre}upload`
      title: '内容回传',
      icon: 'dot-circle-o'
    },
    {
      path: `rmt.gstai.com/sectionFiles`,
      // path: `${pre}library`,
      title: '媒体资源管理',
      icon: 'globe',
      children: [
        { path: `http://rmt.gstai.com/sectionFiles`, title: '媒资库' },
        { path: `http://rmt.gstai.com/sectionFiles`, title: 'AI进度' },
        { path: `http://rmt.gstai.com/sectionFiles`, title: '回收站' }
      ]
    },
    {
      title: '生产工具',
      icon: 'globe',
      children: [
        { path: `https://editor.meishesdk.com/Login`, title: '云非编' },
        { path: `${pre}h5`, title: 'H5编辑' }
      ]
    }
    // { path: `${pre}stat`, title: '使用量统计', icon: 'dot-circle-o' },
  ])('/cloud/')
}
